<template>
    <v-card>
        <div class="modal-header">
            <slot name="modalHeader"></slot>
            <v-layout justify-end>
                <v-flex xs6>
                    <h4>{{ 'app.summary' | trans }}</h4>
                </v-flex>
                <v-flex xs6>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            :label="`app.search.search` | trans"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </div>

        <v-data-table
                :hide-actions="true"
                :items="nutrients"
                :headers="headers"
                :search="search"
                fixed-header
                disable-initial-sort
        >
            <template #items="props">
                <tr>
                    <td>
                        {{ props.item.name}}
                    </td>
                    <td>
                        {{ props.item.total / MENU_DAYS_LENGTH | round }} {{ props.item.unit }}
                    </td>
                    <td>
                        <span :class="indicatorClass( props.item.total, calculateWanted(props.item.id))"
                              v-if="calculateWanted(props.item.id) > 0">
                            <span class="indicator">
                                {{ calculatePercentage(props.item.total, calculateWanted(props.item.id)) | round }}%
                            </span>
                        </span>
                        <span v-else>
                            -
                        </span>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-divider light></v-divider>
        <v-card-actions>
            <v-layout align-center justify-end>
                <v-btn color="primary" flat @click="hideModal">
                    {{ 'app.close' | trans }}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<style lang="scss" type="text/scss" scoped>
    table.v-table tbody td {
        height: 25px;
    }
</style>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import { helpers } from '../../../helpers';
  import { trans } from '../../../app';
  import {
    CARBO, FATS,
    GLICEMIC_INDEX,
    GLICEMIC_LOAD, KCAL,
    NutrientDetailsProvider, PROTEIN,
    WBT,
    WW
  } from "../../../services/NutrientDetailsProvider";

  export default {
    data() {
      return {
        search: '',
      };
    },
    computed: {
      ...mapGetters(['getNutrientsByDay', 'MENU_DAYS_IDS', 'MENU_DAYS_LENGTH', 'MENU_PRESCRIBED_NUTRIENTS', 'MENU_MODE']),
      headers() {
        return [
          { text: trans('app.nutrient'), value: 'name' },
          { text: trans('app.nutrient_avg_by_day'), value: 'average', sortable: false },
          { text: trans('app.percentage'), value: 'percent', sortable: false },
        ];
      },
      nutrients() {
        let schema = [];
        for (const dayId of this.MENU_DAYS_IDS) {
          const nutrientsByDay = this.getNutrientsByDay(dayId);
          for (const externalId in nutrientsByDay) {
            const exist = schema.find((n) => n.id === Number(externalId));
            if (!exist) {
              const nutrientDetails = NutrientDetailsProvider.getById(externalId);
              if (typeof nutrientDetails !== 'undefined') {
                schema.push({
                  id: Number(externalId),
                  name: nutrientDetails.name,
                  unit: nutrientDetails.unit,
                  total: nutrientsByDay[externalId],
                  groupId: nutrientDetails.group_id,
                  position: nutrientDetails.position,
                });
              }
              continue;
            }
            exist.total += nutrientsByDay[externalId];
          }
        }

        const excluded = [WW, WBT, GLICEMIC_INDEX, GLICEMIC_LOAD];
        schema =  schema.filter(n => !excluded.includes(n.id));
        return NutrientDetailsProvider.sortNutrients(schema);
      },
    },
    methods: {
      ...mapMutations([
        'hideModal',
      ]),

      calculateWanted(id) {
        if (!this.MENU_MODE && ![PROTEIN, FATS, CARBO, KCAL].includes(id)) {
          return null;
        }

        const prescribed = this.MENU_PRESCRIBED_NUTRIENTS[id];

        if (!prescribed) {
          return null;
        }

        return prescribed * this.MENU_DAYS_LENGTH;
      },
      ...helpers,
    },
  };
</script>
